import React from 'react';
import { Box, Typography } from '@material-ui/core';

const Footer = () => (
  <Box
    width="100%"
    py={4}
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <Typography variant="body2" color="textSecondary">
      Copyright © {new Date().getFullYear()} Hyunsung Cho
    </Typography>
  </Box>
);

export { Footer };
